import { render, staticRenderFns } from "./ProsecutionTransaction.vue?vue&type=template&id=f8b87362&scoped=true&"
import script from "./ProsecutionTransaction.vue?vue&type=script&lang=js&"
export * from "./ProsecutionTransaction.vue?vue&type=script&lang=js&"
import style0 from "./ProsecutionTransaction.vue?vue&type=style&index=0&id=f8b87362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b87362",
  null
  
)

export default component.exports